<template>
  <div>
    <keep-alive :include="keepAliveViews">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
const KEEP_ALIVE_VIEWS = ['KnowledgePage', 'ResourcesPage', 'ExhibitionPage']

export default {
  name: 'App',
  data() {
    return {
      keepAliveViews: KEEP_ALIVE_VIEWS
    }
  }
}
</script>
